export const CALENDAR_GRID_DROP_SNAP_MINUTES = 15

export const CALENDAR_GRID_DROP_SNAP_MIDPOINT = 0.5
